import { render, staticRenderFns } from "./AgreeDoc.vue?vue&type=template&id=44c926b2&scoped=true"
import script from "./AgreeDoc.vue?vue&type=script&lang=js"
export * from "./AgreeDoc.vue?vue&type=script&lang=js"
import style0 from "./AgreeDoc.vue?vue&type=style&index=0&id=44c926b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c926b2",
  null
  
)

export default component.exports